import { render, staticRenderFns } from "./ReportsInformeClubView.vue?vue&type=template&id=21ce80f3&scoped=true&"
import script from "./ReportsInformeClubView.vue?vue&type=script&lang=js&"
export * from "./ReportsInformeClubView.vue?vue&type=script&lang=js&"
import style0 from "./ReportsInformeClubView.vue?vue&type=style&index=0&id=21ce80f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ce80f3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VIcon,
  VTooltip,
})
